import templateUrl from 'emun.on-demand/templates/od-product-template-documents.htm'
import resolve from 'ioc/resolve'

class ProductTemplateDocumentsController {
}

let ProductTemplateDocumentsComponent = {
    bindings: {
        documents: '=',
        productTemplate: '<?',
        type: '&',
        onAddDocument: '&',
        onRemoveDocument: '&',
        onMoveDocumentUp: '&',
        onMoveDocumentDown: '&'
    },
    controller: ProductTemplateDocumentsController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default ProductTemplateDocumentsComponent;